import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ApiService } from './services';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatDialogModule } from '@angular/material/dialog';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import {
  HAMMER_GESTURE_CONFIG,
  HammerModule
} from '@angular/platform-browser';

import {
  LyTheme2,
  StyleRenderer,
  LY_THEME,
  LY_THEME_NAME,
  LyHammerGestureConfig
} from '@alyle/ui';

/** Import the component modules */
import { LyButtonModule } from '@alyle/ui/button';
import { LyToolbarModule } from '@alyle/ui/toolbar';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LyIconModule } from '@alyle/ui/icon';


/** Import themes */
import { MinimaLight, MinimaDark } from '@alyle/ui/themes/minima';
const materialModule = [
  MatDialogModule
] 

const sharedCoreModules = [
  FormsModule,
  ReactiveFormsModule,
  HttpClientModule,
  ImageCropperModule,
  LazyLoadImageModule,
  LyImageCropperModule,
  LyButtonModule,
  LyToolbarModule,
  LyIconModule,
  LyImageCropperModule,
  HammerModule
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule,
    CommonModule,
    sharedCoreModules,
    materialModule
  ],
  exports: [
    RouterModule,
    sharedCoreModules,
    materialModule
  ],
  providers:[ApiService,
    [ LyTheme2 ],
    [ StyleRenderer ],
    // Theme that will be applied to this module
    { provide: LY_THEME_NAME, useValue: 'minima-light' },
    { provide: LY_THEME, useClass: MinimaLight, multi: true }, // name: `minima-light`
    { provide: LY_THEME, useClass: MinimaDark, multi: true }, // name: `minima-dark`
    // Gestures
    { provide: HAMMER_GESTURE_CONFIG, useClass: LyHammerGestureConfig } // Required for <ly-carousel>
  ]
})
export class CoreModule { }
